module.exports = __webpack_public_path__ + "static/media/xlsx.85c2738d.svg";